"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformProfitLossEntryResponseList = exports.transformProfitLossEntryResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("../Money");
var ProfitLossEntryType;
(function (ProfitLossEntryType) {
    ProfitLossEntryType["debit"] = "debit";
    ProfitLossEntryType["credit"] = "credit";
    ProfitLossEntryType["none"] = "none";
})(ProfitLossEntryType || (ProfitLossEntryType = {}));
function transformProfitLossEntryResponse(response) {
    const childEntries = response.children && response.children.length > 0
        ? response.children.map((child) => transformProfitLossEntryResponse(child))
        : [];
    const dataEntries = response.data && response.data.length > 0
        ? response.data.map((dataEntry) => (0, Money_1.transformMoneyParsedResponse)(dataEntry))
        : [];
    return {
        children: childEntries,
        data: dataEntries,
        description: response.description,
        entryType: response.entry_type,
        total: response.total && (0, Money_1.transformMoneyParsedResponse)(response.total),
    };
}
exports.transformProfitLossEntryResponse = transformProfitLossEntryResponse;
function transformProfitLossEntryResponseList(data) {
    if (data && data.length > 0) {
        return data.map((child) => transformProfitLossEntryResponse(child));
    }
    else {
        return [];
    }
}
exports.transformProfitLossEntryResponseList = transformProfitLossEntryResponseList;
//# sourceMappingURL=ProfitLossEntry.js.map